import { CATEGORIES } from "@/data/calculators";
import { cn } from "@/lib/utils";

export default function CategoryFilter({ value, onChange }) {
  return (
    <div
      data-testid="category-filter"
      className="flex gap-2 overflow-x-auto no-scrollbar pb-1"
      role="tablist"
      aria-label="Calculator categories"
    >
      {CATEGORIES.map((c) => {
        const active = value === c.id;
        return (
          <button
            key={c.id}
            role="tab"
            aria-selected={active}
            data-testid={`cat-${c.id}`}
            onClick={() => onChange(c.id)}
            className={cn(
              "shrink-0 rounded-full border px-4 h-9 text-sm font-medium transition",
              active
                ? "bg-primary text-primary-foreground border-primary"
                : "bg-background text-muted-foreground hover:text-foreground border-border hover:border-foreground/30"
            )}
          >
            {c.label}
          </button>
        );
      })}
    </div>
  );
}
